/**
 * Scripts that run on the welcome page
 */
(
  function (window, document, $, _, undefined) {
    $(document).ready(
      function () {
        const welcomeContents = $('.welcome-webinar-contents'),
          video = $('.welcome-webinar-contents iframe'),
          welcomePlayBtn = welcomeContents.find('.btn-welcome-play');

        // sets up a vimeo player and makes it playable on click
        function showAndPlayVideo () {
          if (video.length > 0) {
            try {
              /**
               * @type {Player}
               */
              const player = new Vimeo.Player(video);
              welcomeContents.children()
                .toggleClass('d-none');
              player.on(
                'ended',
                () => {
                  player.setAutopause(true)
                    .catch(
                      (error) => {
                        switch (error.name) {
                          case 'UnsupportedError':
                            console.log('Autopause is not supported by the current player or browser.');
                            break;
                          default:
                            console.log(`Vimeo encountered a ${error.name}`);
                            break;
                        }
                      }
                    );
                  player.setCurrentTime(0)
                    .then(
                      () => {
                        player.pause()
                          .catch(
                            (error) => {
                              switch (error.name) {
                                case 'PasswordError':
                                  console.log('Incorrect or missing password.');
                                  break;
                                case 'PrivacyError':
                                  console.log('Private Video');
                                  break;
                                default:
                                  console.log(`Vimeo encountered a ${error.name}`);
                                  break;
                              }
                            }
                          );
                      }
                    )
                    .catch(
                      (error) => {
                        switch (error.name) {
                          case 'RangeError':
                            console.log('Selected seek time out of range, i.e. less than 0 or greater than the video\'s duration.');
                            break;
                          default:
                            console.log(`Vimeo encountered a ${error.name}`);
                            break;
                        }
                      }
                    );
                }
              );
              player.play()
                .catch(
                  (error) => {
                    switch (error.name) {
                      case 'PasswordError':
                        console.log('Incorrect or missing password.');
                        break;
                      case 'PrivacyError':
                        console.log('Private Video');
                        break;
                      default:
                        console.log(`Vimeo encountered a ${error.name}`);
                        break;
                    }
                  }
                );
            } catch (error) {
              console.log(error);
            }
          }
        }

        if (welcomeContents.length > 0 && video.length > 0 && welcomePlayBtn.length > 0) {
          welcomePlayBtn.on('click', (e) => {
            e.preventDefault();
            showAndPlayVideo();
          });
        }
      }
    );
  }
)(window, document, window.jQuery, window.lodash);
